import useUrl from './helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('v3/kycaid')
  return {

    /** @returns {Promise<AxiosResponse<GetVerificationProviderStatusResponse>>} */
    getKycaidStatus() {
      const url = root('service_status')
      return client.get(url)
    },
    /** @returns{Promise<AxiosResponse<GetDeeplinkResponse>>} */
    getDeepLinkKycaid() {
      const url = root('form')
      const params = {
        lang: 'uk',
      }
      return client.get(url, { params })
    },

    /** @returns {Promise<AxiosResponse<KycaidUserStatusResponse>>} */
    getUserStatusKycaid() {
      const url = root('user_status')
      return client.get(url)
    },
  }
}

/** @typedef {object} KycaidUserStatusResponse
* @property {object} status
* @property {string} status.status
*/
